import { render, staticRenderFns } from "./bootUpRequest.vue?vue&type=template&id=4565c1c4&scoped=true&"
import script from "./bootUpRequest.vue?vue&type=script&lang=js&"
export * from "./bootUpRequest.vue?vue&type=script&lang=js&"
import style0 from "./bootUpRequest.vue?vue&type=style&index=0&id=4565c1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565c1c4",
  null
  
)

export default component.exports